<h2 mat-dialog-title>Importación de {{'UnidadFuncional' | translate}}</h2>

<div mat-dialog-content>

  <div fxLayout="row stretch" fxLayout.xs="column">

    <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="center">
      <button type="button" mat-raised-button [disabled]="isImporting" (click)="fileInput.click()">Adjuntar archivo</button>
      <input hidden type="file" (change)="convertFileToBase64($event)" #fileInput color="primary">
    </div>
    
    <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="center" style="margin-top: 15px;">
      {{fileName}}
    </div>

  </div>

</div>

<br/>

<div mat-dialog-actions>

  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button (click)="onImportar()" [disabled]="isProcessing()" color="primary" class="zb-button">
      {{isImporting ? 'Importando...' : 'Iniciar Importación'}}
    </button>
    <button mat-raised-button (click)="onDownloadImportTemplate()" [disabled]="isProcessing()" class="zb-button">
      {{isExporting ? 'Descargando...' : 'Descargar Template de Importación'}}
    </button>
    <button mat-raised-button color="warn" (click)="onCancel()" class="zb-button">Cancelar</button>
  </div>

</div>